<template>
  <CCard class="dataTable py-5 mt-3">
    <CRow class="pt-5 pb-4">
      <CCol sm="12" class="d-flex flex-column">
        <div>
          <h2 class="titlePage font-weight-normal text-capitalize">
            {{ $t('organization.subOrganization.subOrganizationList.header1') }}
          </h2>
        </div>
      </CCol>
    </CRow>
    <CCardHeader class="dataTable__header d-flex justify-content-between px-0 pb-5">
      <div class="dataTable__countContants">
        <h3 class="font-weight-normal text-gray-700 mt-3 d-flex align-items-sm-center">
          {{ pagination.totalRecords || 0 }}
          <span class="font-sm font-weight-normal text-uppercase ml-2">{{ $t('organization.subOrganization.subOrganizationList.header1') }}</span>
        </h3>
      </div>
      <div class="dataTable__search">
        <CInput
          type="search"
          placeholder="SEARCH"
          addInputClasses="pl-5"
          class="iconSearchPlaceholder pb-0"
          @input="handleTableFilterChange"
          :disabled="hasNoSubOrganizations"
        ></CInput>
      </div>
      <div class="dataTable__buttonLink">
        <button class="btn btn-primary px-4 py-3 font-weight-bold" tag="button" @click="toCreateSubOrganization()" v-if="cantCreateSub">
          {{ $t('organization.subOrganization.subOrganizationList.button.newsubOrganization') }}
        </button>
      </div>

      <!-- <button @click="testeAcc">acc</button> -->
    </CCardHeader>
    <template v-if="hasNoSubOrganizations">
      <EmptyList
        :loading="loadingGetList"
        :linkText="$t('organization.subOrganization.subOrganizationList.button.newsubOrganization')"
        :linkTo="{ name: 'createSubOrganization' }"
        :title="$t('organization.subOrganization.subOrganizationList.text.noSubOrganization')"
        :subTitle="$t('organization.subOrganization.subOrganizationList.text.newSubOrganization')"
      />
    </template>
    <template v-else>
      <transition name="fade">
        <MenssageAlert :messages="messages" />
      </transition>

      <HeaderActions
        :show="{
          checkItems: true,
          associate: this.showAssociate,
          manage: false,
          filterBy: true,
        }"
        :multiSelect="false"
        :itemsListSelected="Boolean(itemsListSelected)"
        :filterByData="organizationStatusFilterOptions"
        @confirm="deleteItemsSelected"
        @filterBy="chooseFilterBy"
      />

      <CCardBody class="dataTable__body p-0">
        <CDataTable
          :items="registers"
          :fields="headers"
          :table-filter="{ external: true, lazy: true }"
          :table-filter-value.sync="tableFilterValue"
          items-per-page-select
          :items-per-page.sync="itemsPerPage"
          @pagination-change="paginationChange"
          :active-page="1"
          hover
          :loading="loading"
        >
          <template #loading>
            <div class="d-flex justify-content-center align-items-center dataTable__loading">
              <CSpinner class="my-3" color="primary" />
            </div>
          </template>

          <template #status="{ item }">
            <td class="align-middle">
              <span>{{ item.status }}</span>
            </td>
          </template>

          <template #dateCreated="{ item }">
            <td class="align-middle">
              <span>{{ item.dateCreated }}</span>
            </td>
          </template>

          <template #statusId="{ item }">
            <td class="align-middle">
              <span class="text-uppercase d-flex align-items-center">
                <CIcon
                  :name="statusOrder(item.statusId)"
                  :class="statusOrder(item.statusId)"
                  class="mx-2"
                  size="custom-size"
                  :height="19"
                  viewBox="0 0 32 32"
                />
                <u>{{ statusOrder(item.statusId) }}</u>
              </span>
            </td>
          </template>

          <template #companyName="{ item }">
            <td class="align-middle" @click="goToOrganization(item)">
              <span style="text-decoration: underline">
                {{ item.companyName }}
              </span>
            </td>
          </template>

          <template #actions="props">
            <td class="align-middle">
              <v-select
                v-model="selectedAction"
                class="no-close border-gray-300 rounded select"
                :placeholder="$t('organization.subOrganization.subOrganizationList.actions.placeholder')"
                :options="props.item.actions"
                :searchable="false"
                @input="(action) => dispatchRowAction(action, props.item)"
              >
                <template v-slot:option="option">
                  <span :class="{ [option.classes]: true }">{{ option.label }}</span>
                </template>
              </v-select>
            </td>
          </template>

          <template #balanceType="{ item }">
            <td class="align-middle">
              <span>
                {{ statusOrder(item.balanceType) }}
              </span>
            </td>
          </template>

          <template #no-items-view>
            <slot name="no-items">
              <CCol xs="12" sm="6" class="offset-sm-3 text-center emptyCard d-flex flex-column content-center justify-content-center">
                <div>
                  <figure class="mb-5">
                    <img src="/img/site/amico.png" alt="" width="181" />
                  </figure>
                  <h3 class="mb-3">
                    {{ $t('invoices.list.table.empty.title') }}
                  </h3>
                </div>
              </CCol>
            </slot>
          </template>
        </CDataTable>
      </CCardBody>

      <div class="position-relative">
        <CPagination
          v-show="pages > 0 && totalRecords > 0"
          align="center"
          :pages="pages"
          :active-page.sync="activePage"
          class="dataTable__newPagination mt-3"
        >
          <template slot="previous-button">
            <span class="newPagination__button p-2 btnPagination">
              {{ $t('audience.audienceList.text.prev') }}
            </span>
          </template>
          <template slot="next-button">
            <span class="newPagination__button p-2 btnPagination">
              {{ $t('audience.audienceList.text.next') }}
            </span>
          </template>
        </CPagination>
        <CElementCover v-if="loading" :opacity="0.8" style="z-index: 1001">
          <div></div>
        </CElementCover>
      </div>
    </template>
    <ChangeOrganizationParentModal ref="changeOrganizationParentModalRef" @parentChanged="getData" />
  </CCard>
</template>

<script>
import HeaderActions from '@/components/table/HeaderActions'
import MenssageAlert from '@/components/MenssageAlert'
import { dateTimeFormatString } from '../../../utils/dateUtil'
// import fileDownload from "js-file-download";
import EmptyList from '@/components/EmptyList'
import services from '@/services.js'
import vSelect from 'vue-select'
import ChangeOrganizationParentModal from '../components/ChangeOrganizationParentModal.vue'

export default {
  name: 'SubOrganizationList',
  components: {
    MenssageAlert,
    HeaderActions,
    EmptyList,
    vSelect,
    ChangeOrganizationParentModal,
  },
  data() {
    return {
      loadingGetList: false,
      columnFilterValue: {},
      tableFilterValue: null,
      loadedItems: [],
      loading: false,
      itemsPerPage: 10,
      pages: 0,
      headers: ['companyName', 'status', 'dateCreated', 'actions', 'Balance Type'],
      totalPendings: 0,
      totalRecords: 0,
      totalPages: 0,
      itemsListSelected: null,
      activePage: 1,
      responsive: false,
      messages: [],
      organizationStatusId: null,
      collapseDuration: 0,
      details: [],
      pagination: {},
      featuresIds: ['SUB_ORGANIZATIONS'],
      canCreateNewSub: false,
      searchFilterTimeout: null,
      searchFilterTime: 1500,
      actionTypes: {
        edit: 1,
        changeOrganizationParent: 2,
        distributeBalance: 3,
      },
      selectedAction: null,
    }
  },

  created() {
    this.loadingGetList = true
    this.getData()
  },

  mounted() {
    // this.$root.$on('approveOrReprove', (obj) => {
    //   this.approveOrReprove(obj)
    // })
    // this.getOrganizationUsers()

    this.canCreateNewSuborganization()
  },

  watch: {
    reloadParams() {
      this.onTableChange()
    },
  },

  computed: {
    cantCreateSub() {
      let subOrganizationMaxCount = this.$store.getters['auth/subOrganizationMaxCount'] //800
      let featureEnabled = this.$store.getters['auth/featureCreateSubOrganizationEnabled'] //true

      let userCanCreateSubAccount = false

      if (this.canCreateNewSub) {
        userCanCreateSubAccount = true
      }
      if (this.loadedItems.length >= subOrganizationMaxCount && featureEnabled) {
        userCanCreateSubAccount = false
      }
      if (this.loadedItems.length < subOrganizationMaxCount && featureEnabled) {
        userCanCreateSubAccount = true
      }
      if (featureEnabled == false) {
        userCanCreateSubAccount = false
      }
      if (subOrganizationMaxCount == null) {
        userCanCreateSubAccount = true
      }

      return userCanCreateSubAccount
    },

    registers() {
      return this.loadedItems.map((sender) => {
        return {
          ...sender,
        }
      })
    },

    itemsPending() {
      return 0
      // return this.loadedItems.find(item => item.statusIdto == 1)
    },

    showApproveRefuse() {
      // só mostra a featuea de aprovação se  status por pedding
      const item = this.loadedItems.find((item) => item.id == this.itemsListSelected) || null
      return item ? item.statusId == 1 : null // 1 == pedding
    },

    showAssociate() {
      // só mostra a feature de associaçao se  status por approved
      const item = this.loadedItems.find((item) => item.id == this.itemsListSelected) || null
      return item ? item.statusId == 2 : null // 2 == approved
    },

    reloadParams() {
      return [this.activePage, this.itemsPerPage, this.tableFilterValue, this.organizationStatusId]
    },

    detailPagination() {
      const first = (this.activePage - 1) * this.itemsPerPage
      const totalPage = this.activePage * 10 > this.totalRecords ? this.totalRecords : this.activePage * 10
      return `${first} - ${totalPage}  of ${this.totalRecords}`
    },

    hasNoSubOrganizations() {
      return this.totalPages == 0 && !this.tableFilterValue && !this.organizationStatusId
    },

    organizationStatusFilterOptions() {
      return [
        { column: 'organizationStatusId', value: 2, label: this.$t('organization.subOrganization.filterOptions.active') },
        { column: 'organizationStatusId', value: 1, label: this.$t('organization.subOrganization.filterOptions.inactive') },
      ]
    },
  },

  methods: {
    goToOrganization(row) {
      this.$store.dispatch('auth/selectOrganization', { value: row.organizationId }).then((res) => {
        this.$store.commit('SHOW_BASE_MENU')
        this.$router.push({ name: 'home', params: { organizationId: row.organizationId } })
      })
    },
    toCreateSubOrganization() {
      this.$router.push({ name: 'createSubOrganization' })
    },

    formatDate(date) {
      return date ? dateTimeFormatString(date) : ''
    },

    canCreateNewSuborganization() {
      let organizationId = this.$route.params.organizationId
      services.canCreateNewSuborganization(organizationId).then((res) => {
        this.canCreatenewSub = res.data.data
      })
    },

    headerHandle() {
      return [
        {
          key: 'companyName',
          label: this.$t('general.table.header.companyName'),
        },
        {
          key: 'status',
          label: this.$t('general.table.header.status'),
        },
        {
          key: 'dateCreated',
          label: this.$t('general.table.header.createDate'),
        },
        {
          key: 'actions',
          label: this.$t('general.table.header.actions'),
        },
        {
          key: 'balanceType',
          label: this.$t('general.table.header.balanceType'),
        },
      ]
    },

    mountItemsTable(arr) {
      let result = arr
        .filter((elm) => elm.id != this.$store.state.auth.organizationId)
        .map((elm) => {
          return {
            companyName: elm.companyName,
            organizationId: elm.organizationId,
            dateCreated: dateTimeFormatString(elm.createdDateTime),
            status: elm.inactiveDateTime === null ? 'Active' : 'Inactive',
            balanceType: elm.organizationBalanceConfigType,
            actions: this.getRowActions(elm),
            _selected: false,
          }
        })

      return result
    },

    getData() {
      this.loading = true
      services
        .getSubOrganizationsNew(
          this.$route.params.organizationId,
          this.activePage,
          this.itemsPerPage,
          this.tableFilterValue,
          this.organizationStatusId,
        )
        .then((res) => {
          this.pages = Math.ceil(res.data.data.pageOptionsResponse.totalRecords / 10)
          this.totalInvites = res.data.data.items.length
          this.totalRecords = res.data.data.pageOptionsResponse.totalRecords
          this.totalPages = res.data.data.pageOptionsResponse.totalPages
          this.activePage = res.data.data.pageOptionsResponse.currentPage
          this.headers = this.headerHandle()
          this.loadedItems = this.mountItemsTable(res.data.data.items)
          this.pagination = res.data.data.pageOptionsResponse
        })
        .catch(() => {
          this.loadedItems = []
        })
        .finally(() => {
          this.loading = false
          this.loadingGetList = false
        })
    },

    onTableChange() {
      this.loading = true
      this.getData()
    },

    paginationChange(a) {
      this.itemsPerPage = a
    },

    check(item) {
      this.$set(this.loadedItems[item.index], '_selected', !this.loadedItems[item.index]._selected)
      this.itemsListSelected = item.id

      this.$store.dispatch('senders/setSender', item.organizationSender.id)
    },

    isApprovedSender(id) {
      return this.loadedItems.filter((item) => item.id == id)[0].statusId == 2 //approved
    },

    deleteItemsSelected() {
      this.messages = []

      if (!this.isApprovedSender(this.itemsListSelected)) {
        this.messages.push({
          status: 'warning',
          text: 'You can delete only approved senders',
        })
        return
      }
      let organizationId = this.$store.state.auth.organizationId

      services
        .deleteSender(organizationId, this.itemsListSelected)
        .then(({ data }) => {
          this.onTableChange()

          this.messages.push({
            status: 'success',
            text: data.message ? data.message : 'selected items have been deleted',
          })

          setTimeout(() => {
            this.itemsListSelected = null
          }, 1000)
        })
        .catch(({ response }) => {
          this.messages.push({
            status: 'danger',
            text: response.data.message,
          })
        })
    },

    statusOrder(position) {
      const positions = {
        1: this.$t('organization.subOrganization.subOrganizationList.consumes-from-parent'),
        2: this.$t('organization.subOrganization.subOrganizationList.distributed-from-parent'),
        3: this.$t('organization.subOrganization.subOrganizationList.indepedent'),
      }

      return positions[position] || positions.default
    },

    statusOrganization(position) {
      const positions = {
        1: 'active',
        2: 'inactive',
      }

      return positions[position] || positions.default
    },

    chooseFilterBy(item) {
      this.organizationStatusId = null

      this[item.column] = item.value
    },

    // approveOrReprove(obj) {
    //   this.messages = []
    //   try {
    //     let item = this.loadedItems.find((item) => item.id === this.itemsListSelected)
    //     let organizationId = this.$store.state.auth.organizationId

    //     services
    //       .approveorreject(organizationId, {
    //         senderRequestId: item.id,
    //         sender: item.sender,
    //         status: obj.status,
    //         reasonText: obj.reasonText,
    //       })
    //       .then(() => {
    //         this.onTableChange()
    //       })
    //       .catch((error) => {
    //         this.messages.push({
    //           status: 'danger',
    //           text: error.response.data.message,
    //         })
    //       })
    //   } catch (error) {
    //     this.messages.push({
    //       status: 'danger',
    //       text: error.response.data.message || '',
    //     })
    //   }
    // },

    // getOrganizationUsers() {
    //   this.$store.dispatch('senders/organizationUsers', this.$store.state.auth.organizationId)
    // },

    hasLink(item) {
      if (item.balanceType == 2) {
        this.$router.push({
          name: 'manage-balance-distributed',
          params: { targetOrganizationId: item.organizationId },
        })
      }
      // return item.balanceType == 2
      //   ? {
      //       name: 'manage-balance-distributed',
      //       params: { targetOrganizationId: item.organizationId },
      //     }
      //   : null
    },

    handleTableFilterChange(value) {
      if (!value) {
        this.tableFilterValue = value
        this.activePage = 1
        return
      }

      if (this.searchFilterTimeout) {
        clearTimeout(this.searchFilterTimeout)
      }

      this.searchFilterTimeout = setTimeout(() => {
        this.tableFilterValue = value
        this.activePage = 1
      }, this.searchFilterTime)
    },

    getRowActions(row) {
      const rowActions = [{ value: this.actionTypes.edit, label: this.$t('organization.subOrganization.subOrganizationList.button.edit') }]

      if (this.$store.getters['auth/hasSessionPermission']('Organization_Edit_Parent')) {
        rowActions.push({
          value: this.actionTypes.changeOrganizationParent,
          label: this.$t('organization.subOrganization.subOrganizationList.button.move-organization'),
        })
      }

      if (row.organizationBalanceConfigType === 2) {
        rowActions.push({
          value: this.actionTypes.distributeBalance,
          label: this.$t('organization.subOrganization.subOrganizationList.button.distribute-balance'),
        })
      }

      return rowActions
    },

    dispatchRowAction(action, item) {
      this.selectedAction = null

      if (!action) return

      switch (action.value) {
        case this.actionTypes.edit:
          this.$store.dispatch('auth/selectOrganization', { value: item.organizationId }).then(() => {
            this.$router.push({ name: 'mainOrganization', params: { organizationId: item.organizationId } })
          })
          break
        case this.actionTypes.changeOrganizationParent:
          this.$refs.changeOrganizationParentModalRef.openModal(item.organizationId)
          break
        case this.actionTypes.distributeBalance:
          this.$router.push({
            name: 'manage-balance-distributed',
            params: { targetOrganizationId: item.organizationId },
          })
          break
        default:
          break
      }
    },
  },
}
</script>
<style scoped lang="scss">
.pending {
  color: var(--warning);
}

.active,
.approved {
  color: var(--success);
}

.refused {
  color: var(--danger);
}

.listItem__download {
  cursor: pointer;
}

.listItem__name {
  flex: 0 0 20%;
  min-width: 250px;
}

.listItem__numbers {
  font-size: $font-size-xs;
  position: relative;
}

.listItem__detail {
  flex-wrap: wrap;
}

.listItem__detailItem {
  flex: 0 0 25%;
  margin-bottom: 2%;

  &.big {
    flex: 0 0 50%;
  }
}

.select {
  width: 140px;
}
</style>

<style module>
.blockClick {
  pointer-events: none;
}
</style>
